<template>
  <el-main :class="[queding=='工程首页'?'zong':'bzong']">
    <div style="position:relative">
      <page-title :class="[queding=='工程首页'?'shou':'']">
        {{ title }}
      </page-title>
      <div v-if="title=='项目管理'" style="position:absolute;top:20px;right:10px;">
        <el-button @click="newProj" style="margin-top: 20px;float: right;width:139px;height: 33px;line-height: 8px;" size="mini">新建项目</el-button>
      </div>
    </div>

    <div class="Main" :style="{'background':getBackground,'padding':getPadding}">
      <keep-alive style="width:100%;height:100%" include="物联网卡管理" >
        <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath" style="width:100%;height:100%" ></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath" style="width:100%;height:100%"></router-view>
    </div>



  

  </el-main>
</template>
<script>
import { EventBus } from './bus'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      selfpower: true,
      usetype: null,
      dialogTableVisible: false,
      dialogVisible: false,
      dialogImageUrl: '',
      imageUrl: require('../../assets/15C.jpg'),
      url2: require('../../assets/15C.jpg')

    }
  },
   watch: {
    // 监听路由变化，处理缓存逻辑
    $route(to, from) {
      // 如果从orderjiekou返回到decideValue，设置标记
      if (from.name === 'orderjiekou' && to.name === '物联网卡管理') {
        to.meta.isFromOrderJiekou = true
      }
      
      // 如果从decideValue去往非orderjiekou的页面，清除缓存标记
      if (from.name === '物联网卡管理' && to.name !== 'orderjiekou') {
        from.meta.isFromOrderJiekou = false
      }
    }
  },
  
  name: 'Layout',
  computed: {
    ...mapGetters([
      'title',
    ]),
    queding() {
      return this.$route.name
    },
    getBackground() {
      return this.$route.name === "工程首页" ? 'rgb(239,239,239)' : 'rgb(255,255,255)'
    },
    getPadding() {
      return this.$route.name === "工程首页" ? '0' : '20px'
    }
  },
  methods: {
    newProj() {
      EventBus.$emit('my-event', true)
    },
  
   

  },
  mounted() {
    this.usetype = localStorage.getItem('company')
  }

}

</script>

<style scoped>
.zong {
  padding: 0;
  overflow: auto;
  background: rgb(239, 239, 239);
  margin: 0px !important;
}
.bzong {
  overflow: auto;
  padding: 0 40px;
  background: rgb(239, 239, 239);
}
.shou {
  font-size: 17px !important;
  padding: 9px 40px 9px !important;
  background-color: #bfd990 !important;
}
.Main {
  min-height: calc(100% - 181px);
  display:flex;
  flex-direction: column;
}
>>> .el-button {
  border-radius: unset !important;
}
>>> .el-button--success {
  background-color: #2f5077 !important;
  border-color: #2f5077 !important;
}
>>> .el-button--success:hover {
  background-color: #2f5077 !important;
  border-color: #2f5077 !important;
}
>>> .el-button--success.is-plain {
  background-color: #fff !important;
  color: #2f5077 !important;
  border-color: #2f5077 !important;
}
.pic {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
<style>
</style>


// WEBPACK FOOTER //
// src/components/Layout/Main.vue